module.exports = __webpack_public_path__ + "images/柏纳长图_09.jpg?v=943a45d8";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_09.jpg
 ** module id = 150
 ** module chunks = 1 2
 **/